export const ECHO_WIDGET_CDN_URL = `https://${process.env.UI_ASSETS_CDN_URL}/echo/echo-widget.js`;

export const ECHO_WIDGET_ID = process.env.ECHO_WIDGET_ID || 'echo_wid_9d75e4d5bfb08aaaae5f71fe';
export const ECHO_BACKEND_URL = process.env.ECHO_BACKEND_URL || '/docops/echo';

export const ECHO_EVENTS = {
  PANEL_OPENED: 'echo:panel.opened',
  PANEL_CLOSED: 'echo:panel.closed',
  SUPPORT_REQUESTED: 'echo:support.requested',
} as const;
